module.exports = __webpack_public_path__ + "img/txhbcgj32.662f2991.svg";